module.exports = __webpack_public_path__ + "static/media/lenta.148b5be3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/forum/lenta.svg
// module id = ./src/assets/media/forum/lenta.svg
// module chunks = 16